import { AvailabilityAssignmentDisplayStatus } from '../../domain/collector-availability-overview.model';

export const AVAILABILITY_DAY_MINUTES = 1440;
export const AVAILABILITY_DEFAULT_PAGE_SIZE = 20;
export const AVAILABILITY_PAGE_SIZE_OPTIONS = [10, 20, 50] as const;
export const AVAILABILITY_SLIDER_STEP_MINUTES = 15;

export interface TimelineLabelPosition {
  leftPercent: number;
  transform: string;
}

export function clampMinute(minute: number): number {
  if (Number.isNaN(minute)) {
    return 0;
  }
  return Math.max(0, Math.min(AVAILABILITY_DAY_MINUTES, minute));
}

export function minuteToPercentage(minute: number): number {
  return (clampMinute(minute) / AVAILABILITY_DAY_MINUTES) * 100;
}

export function formatMinuteOfDay(minute: number): string {
  const normalizedMinute = Math.floor(clampMinute(minute));
  const hours = Math.floor(normalizedMinute / 60);
  const minutes = normalizedMinute % 60;
  return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`;
}

export function formatDuration(minutes: number): string {
  const normalizedMinutes = Number.isFinite(minutes)
    ? Math.max(0, Math.floor(minutes))
    : 0;
  const hours = Math.floor(normalizedMinutes / 60);
  const remainingMinutes = normalizedMinutes % 60;

  if (hours === 0) {
    return `${remainingMinutes}m`;
  }
  if (remainingMinutes === 0) {
    return `${hours}h`;
  }
  return `${hours}h ${remainingMinutes}m`;
}

export function getTimelineLabelPosition(
  minute: number
): TimelineLabelPosition {
  const normalizedMinute = clampMinute(minute);
  let transform = 'translateX(-50%)';
  if (normalizedMinute === 0) {
    transform = 'translateX(0)';
  } else if (normalizedMinute === AVAILABILITY_DAY_MINUTES) {
    transform = 'translateX(-100%)';
  }

  return {
    leftPercent: minuteToPercentage(normalizedMinute),
    transform
  };
}

export function formatAssignmentDisplayStatus(
  displayStatus: AvailabilityAssignmentDisplayStatus | undefined
): string {
  return displayStatus ?? '';
}
